// Date 2025-02-22 10:12:25

import ppeInventoryEdit from "@/views/em/ppe/PpeInventoryEdit.vue";
import ppeInventoryList from "@/views/em/ppe/PpeInventoryList.vue";
import ppeInventoryQueryView from "@/views/em/ppe/PpeInventoryQueryView.vue";
import ppeApplyRecordTask from "@/views/em/ppe/PpeApplyRecordTask.vue";
import ppeApplyRecordList from "@/views/em/ppe/PpeApplyRecordList.vue";
import ppeApplyRecordEdit from "@/views/em/ppe/PpeApplyRecordEdit.vue";
import ppeApplyRecordDetailEdit from "@/views/em/ppe/PpeApplyRecordDetailEdit.vue";
import ppeApplyRecordDetailList from "@/views/em/ppe/PpeApplyRecordDetailList.vue";
import ppeApplyRecordHistoryEdit from "@/views/em/ppe/PpeApplyRecordHistoryEdit.vue";
import ppeApplyRecordHistoryList from "@/views/em/ppe/PpeApplyRecordHistoryList.vue";
import ppeHome from "@/views/em/ppe/mobile//PpeHome.vue";
import ppeApply from "@/views/em/ppe/mobile//PpeApply.vue";
import ppeApplyScrapEdit from "@/views/em/ppe/PpeApplyScrapEdit.vue";
import ppeApplyScrapTask from "@/views/em/ppe/PpeApplyScrapTask.vue";
import ppeApplyScrapList from "@/views/em/ppe/PpeApplyScrapList.vue";
import ppeApplyScrapDetailList from "@/views/em/ppe/PpeApplyScrapDetailList.vue";
import ppeApplyScrapDetailEdit from "@/views/em/ppe/PpeApplyScrapDetailEdit.vue";
import ppeDeptManagerDictEdit from "@/views/em/ppe/PpeDeptManagerDictEdit.vue";
import ppeDeptManagerDictList from "@/views/em/ppe/PpeDeptManagerDictList.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
    {
        path: "/em/ppe/ppeInventoryEdit",
        name: "ppeInventoryEdit",
        component: ppeInventoryEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeInventoryList",
        name: "ppeInventoryList",
        component: ppeInventoryList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeInventoryQueryView",
        name: "ppeInventoryQueryView",
        component: ppeInventoryQueryView
    },
    {
        path: "/em/ppe/ppeApplyRecordTask",
        name: "ppeApplyRecordTask",
        component: ppeApplyRecordTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyRecordList",
        name: "ppeApplyRecordList",
        component: ppeApplyRecordList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyRecordEdit",
        name: "ppeApplyRecordEdit",
        component: ppeApplyRecordEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyRecordDetailEdit",
        name: "ppeApplyRecordDetailEdit",
        component: ppeApplyRecordDetailEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyRecordDetailList",
        name: "ppeApplyRecordDetailList",
        component: ppeApplyRecordDetailList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyRecordHistoryEdit",
        name: "ppeApplyRecordHistoryEdit",
        component: ppeApplyRecordHistoryEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyRecordHistoryList",
        name: "ppeApplyRecordHistoryList",
        component: ppeApplyRecordHistoryList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: '/em/ppe/home',
        component: ppeHome,
        meta: {requiresAuth: false},
    },
    {
        path: '/em/ppe/apply',
        component: ppeApply,
        meta: {requiresAuth: false},
    },
    {
        path: "/em/ppe/ppeApplyScrapEdit",
        name: "ppeApplyScrapEdit",
        component: ppeApplyScrapEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyScrapTask",
        name: "ppeApplyScrapTask",
        component: ppeApplyScrapTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyScrapList",
        name: "ppeApplyScrapList",
        component: ppeApplyScrapList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyScrapDetailList",
        name: "ppeApplyScrapDetailList",
        component: ppeApplyScrapDetailList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeApplyScrapDetailEdit",
        name: "ppeApplyScrapDetailEdit",
        component: ppeApplyScrapDetailEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeDeptManagerDictEdit",
        name: "ppeDeptManagerDictEdit",
        component: ppeDeptManagerDictEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/ppe/ppeDeptManagerDictList",
        name: "ppeDeptManagerDictList",
        component: ppeDeptManagerDictList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]